import type { SendMicrosoftEmail } from '@cloudFunctions/types/microsoft/sendMicrosoftEmail';
import type { BackendRouteDefinition } from '../types';

// Phase 5 / Sub-phase 2 / `S2-WB1` — flipped from `transport: 'callable'` to
// `transport: 'api'`. The 4 routes target `api-core-node` at
// `/api/firms/microsoft/...`. The OAuth callback (`exchangeMicrosoftAuthCode`)
// also lives on `api-core-node` (at `/api/oauth/microsoft/callback`) so it
// inherits the warm-start `minInstances: 1` budget — the popup blocks on
// that response, so a cold-start would visibly slow the user's connect
// flow. It is invoked by Microsoft directly during the redirect and
// therefore has no firms-app caller and no entry here.

export const generateMicrosoftAuthUrlRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/microsoft/auth-url',
} as const satisfies BackendRouteDefinition;

export const getMicrosoftCredentialsRoute = {
  transport: 'api',
  method: 'GET',
  path: '/firms/microsoft/credentials',
} as const satisfies BackendRouteDefinition;

export const revokeMicrosoftCredentialsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/microsoft/revoke',
} as const satisfies BackendRouteDefinition;

export const sendMicrosoftEmailRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/microsoft/send-email',
  body: (requestData: SendMicrosoftEmail.RequestData) => requestData,
} as const satisfies BackendRouteDefinition;
